import ModalInTailwind from '$components/ModalInTailwind/ModalInTailwind';
import SPKEmployerCandidateFeedBackModal from '$components/Positions/SPKCandidatesPositionPage/SPKEmployerPositionCandidateCard/SPKEmployerCandidateFeedBackModal';
import { useAppDispatch } from '$hooks/use-app-dispatch.hook';
import { useAppSelector } from '$hooks/use-app-selector.hook';
import { singlePositionSlice } from '$store/modules/position/position.reducer';

type SPKNotAFitFeedbackModalProps = {
  positionId: number;
};

const SPKNotAFitFeedbackModal = ({
  positionId,
}: SPKNotAFitFeedbackModalProps) => {
  const dispatch = useAppDispatch();
  const { selectedCandidate, openFeedbackModal } = useAppSelector(
    (state) => state.position
  );

  return (
    <ModalInTailwind
      isOpen={openFeedbackModal}
      closeModal={() =>
        dispatch(singlePositionSlice.actions.setOpenFeedbackModal(false))
      }
    >
      <SPKEmployerCandidateFeedBackModal
        candidateId={selectedCandidate?.Id as number}
        closeHandler={() =>
          dispatch(singlePositionSlice.actions.setOpenFeedbackModal(false))
        }
        position={positionId}
      />
    </ModalInTailwind>
  );
};

export default SPKNotAFitFeedbackModal;
